import React, { useState, useEffect } from 'react';

export default function Modal({ visible, children }) {

    const [showModal, setShowModal] = useState(false);
    const [fadeModal, setFadeModal] = useState(false);

    useEffect(() => {
        if (visible) {
            setShowModal(true);
            setTimeout(() => setFadeModal(true));
        }
        else {
            setFadeModal(false);
            setTimeout(() => setShowModal(false), 200);
        }
    }, [visible]);

    return(
        showModal &&
            <div className={fadeModal ? 'modal active' : 'modal'}>
                { children }
            </div>
    );

}
